import * as React from 'react';
import { cn } from '@/lib/utils';

export type StatusVariant =
  | 'active'
  | 'inactive'
  | 'warning'
  | 'info'
  | 'error'
  | 'purple';

interface StatusBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant: StatusVariant;
  children: React.ReactNode;
}

const baseStyles =
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2';

const variantStyles: Record<StatusVariant, string> = {
  active: 'border-transparent bg-green-100 text-green-800 hover:bg-green-100',
  inactive: 'border-transparent bg-gray-100 text-gray-800 hover:bg-gray-100',
  warning: 'border-transparent bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
  info: 'border-transparent bg-blue-100 text-blue-800 hover:bg-blue-100',
  error: 'border-transparent bg-red-100 text-red-800 hover:bg-red-100',
  purple: 'border-transparent bg-purple-100 text-purple-800 hover:bg-purple-100',
};

export const StatusBadge = React.forwardRef<HTMLDivElement, StatusBadgeProps>(
  ({ variant, children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(baseStyles, variantStyles[variant], className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

StatusBadge.displayName = 'StatusBadge';
